import { ca } from '@cian/analytics';

import type { TNewbuildingsMapPlatform } from '../../components/NewbuildingsMap';

interface INewbuildingMapEvent {
  newbuildingId: number;
  builderId?: number;
}

const PAGE = {
  pageType: 'ListingCompareJK',
  siteType: 'desktop',
};

function getDesktopPage(builderId?: number) {
  return builderId ? { ...PAGE, extra: { from_object: builderId } } : PAGE;
}

/** Клик на «Все ЖК на карте». */
export function trackOpenMap(newbuildingIds: number[], platform: TNewbuildingsMapPlatform = 'desktop') {
  ca('eventSite', {
    name: 'oldevent',
    category: 'newbuilding_on_map',
    action: 'click',
    label: 'show_all',
    products: newbuildingIds.map(id => ({ id, offerType: 'JK' })),
    page: { ...PAGE, siteType: platform },
  });
}

/** Клик на пин ЖК на карте. */
export function trackPinClick({ newbuildingId, builderId }: INewbuildingMapEvent) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'CompareJK',
    action: 'click_map_pin',
    products: [{ id: newbuildingId, offerType: 'JK' }],
    page: getDesktopPage(builderId),
  });
}

/** Клик на «Подробнее о ЖК» в превью пина. */
export function trackNavigationToCardJKFromMap({ newbuildingId, builderId }: INewbuildingMapEvent) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'CompareJK',
    action: 'click',
    label: 'about_jk',
    products: [{ id: newbuildingId, offerType: 'JK' }],
    page: getDesktopPage(builderId),
  });
}

/** Расхлоп телефона в превью пина. */
export function trackShowPhoneFromMap({ newbuildingId, builderId }: INewbuildingMapEvent) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Phones',
    action: 'Open_compare_jk_map_block',
    products: [{ id: newbuildingId, offerType: 'JK' }],
    page: getDesktopPage(builderId),
  });
}
